import { Attachment, Translations } from '@/types/types';
import { QueryKey } from '@/configs/queryKeys';
import { AttributeValue } from './AttributeValueApi';
import { ProductModule } from './ProductModuleApi';
import EntityApi, { BaseEntity } from './EntityApi';

export interface ProductModuleCollection extends BaseEntity {
	name: string;
	code: string;
	listOrder: number;
	image?: Attachment;
	attributeValues: AttributeValue[];
	defaultAttributeValues: AttributeValue[];
	defaultModule: ProductModule;
	description: string;
	shopUrl?: string;
	translations: Translations<{
		name: string;
	}>;
}

class ProductModuleCollectionApi extends EntityApi<ProductModuleCollection> {
	constructor() {
		super(QueryKey.productModuleCollections);
	}
}

export default new ProductModuleCollectionApi();
